module.exports = __webpack_public_path__ + "img/constelacion-logoblanco.3541041a.svg";